import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

import { useWindowSize } from '../../../hooks/helpers/useWindowSize';
import { TOPBAR_HEIGHT } from '../../atoms';

const SIDE_PANEL_WIDTH = 308;

type PageSidePanelProps = PropsWithChildren<{
	/**
	 * Force rendering the side panel even if there is no content. Used for avoiding layout shifts
	 * */
	forceRender?: boolean;
}>;

export const PageSidePanel = ({ children, forceRender = false }: PageSidePanelProps) => {
	const { size } = useWindowSize();

	if ((!children && !forceRender) || size !== 'desktop') {
		return null;
	}

	return (
		<S.PageSidePanelWrapper>
			<S.ChildrenWrapper>{children}</S.ChildrenWrapper>
		</S.PageSidePanelWrapper>
	);
};

namespace S {
	export const PageSidePanelWrapper = styled.div`
		padding: ${({ theme }) =>
			`${theme.spacings.xlarge} ${theme.spacings.xlarge} ${theme.spacings.xxlarge} ${theme.spacings.medium}`};
	`;
	export const ChildrenWrapper = styled.div`
		display: flex;
		flex-direction: column;
		position: sticky;
		top: ${TOPBAR_HEIGHT}px;
		gap: ${({ theme }) => theme.spacings.small};
		${({ theme }) => theme.breakpoints.queries.only.largeDesktop} {
			padding-right: ${({ theme }) => theme.spacings.medium};
		}
		width: ${SIDE_PANEL_WIDTH}px;
		padding-top: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
